import { render, staticRenderFns } from "./TermsConditionsComponent.vue?vue&type=template&id=20f93a88&"
import script from "./TermsConditionsComponent.vue?vue&type=script&lang=js&"
export * from "./TermsConditionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TermsConditionsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports